import {createFileRoute} from '@tanstack/react-router';
import {CreditAccountTransactionsPage} from '../../../../../../features/credit/pages/CreditAccountTransactionsPage/CreditAccountTransactionsPage';

export const Route = createFileRoute(
  '/_protected/home/accounts/credits/$accountId/transactions',
)({
  component: CreditAccountTransactionsPage,
  staticData: {crumbKey: 'navigation.transactions'},
});
